import { DateTime } from 'luxon';
import styled, { css } from 'styled-components';

import ConnectedEventTimeline from 'dashboard/components/ConnectedEventTimeline';
import { default as EventTimelinePreview } from 'dashboard/components/EventTimeline';
import PersonaErrorBoundary from 'dashboard/components/PersonaErrorBoundary';
import { Account } from 'dashboard/models/account';
import { Case } from 'dashboard/models/case';
import { Environment } from 'dashboard/models/environment';
import { Transaction } from 'dashboard/models/transaction';
import { ModuleEventTimeline } from 'dashboard/modules/EventTimeline';
import Card from 'design-system/components/Card';
import { TIMEZONE_NAME_ABBREVIATED } from 'lib/constants/luxonFormats';
import { ApiResource } from 'lib/interfaces/api';
import { captureMessage } from 'lib/reporting';

const EventTimelineCard = styled(Card)<{ dynamicHeight: boolean }>`
  margin: 0;
  ${({ dynamicHeight }) =>
    dynamicHeight
      ? css`
          height: auto;
        `
      : css`
          height: 100%;
        `}
`;

export interface EventTimelineProps {
  module: ModuleEventTimeline;
  subject: Case | Account | Transaction;
  objects: ApiResource[];
  currentEnvironment: Environment;
  isPreview?: boolean;
}

const EventTimeline = ({
  module,
  subject,
  objects,
  currentEnvironment,
  isPreview = false,
}: EventTimelineProps) => {
  const hasDynamicHeight = module['module-layout']['dynamic-height'];
  const location = subject.type;

  return (
    <EventTimelineCard dynamicHeight={hasDynamicHeight}>
      <Card.Body>
        <Card.Title>
          Event timeline ({DateTime.local().toFormat(TIMEZONE_NAME_ABBREVIATED)})
        </Card.Title>
        <PersonaErrorBoundary
          onCatch={(error) =>
            captureMessage('Event timeline failed to load', 'error', {
              error,
              object: subject.id,
              component: 'modules/EventTimeline',
            })
          }
        >
          {isPreview ? (
            <EventTimelinePreview
              caseAssignmentPolicies={[]}
              events={[]}
              workflowIdToNameMap={{}}
              workflowRuns={[]}
              users={[]}
              importerPipelineMap={{}}
              location={location}
            />
          ) : (
            <ConnectedEventTimeline
              objects={[subject, ...objects]}
              location={location}
              currentEnvironment={currentEnvironment}
            />
          )}
        </PersonaErrorBoundary>
      </Card.Body>
    </EventTimelineCard>
  );
};

export default EventTimeline;
